export const brandIconList = [
    { brand: 'visa', icon: require('@/assets/payments/visa.webp') },
    { brand: 'mastercard', icon: require('@/assets/payments/mastercard.webp') },
    { brand: 'paypal', icon: require('@/assets/payments/paypal.webp') },
    { brand: 'maestro', icon: require('@/assets/payments/maestro.webp') },
    { brand: 'diners', icon: require('@/assets/payments/diners_club.webp') },
    { brand: 'discover', icon: require('@/assets/payments/discover.webp') },
    { brand: 'jcb', icon: require('@/assets/payments/jcb.webp') },
    { brand: 'amex', icon: require('@/assets/payments/american_express.webp') },
    { brand: 'americanexpress', icon: require('@/assets/payments/american_express.webp') },
    { brand: 'unionpay', icon: require('@/assets/payments/unionpay.webp') },
    { brand: 'redcompra', icon: require('@/assets/payments/redcompra.webp') },
];
